var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDislikeIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 18.5H22.6667C23.5871 18.5 24.3333 17.7538 24.3333 16.8333V11C24.3333 10.0795 23.5871 9.33333 22.6667 9.33333H21C20.0795 9.33333 19.3333 10.0795 19.3333 11V16.8333C19.3333 17.7538 20.0795 18.5 21 18.5Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7692 8.5H15.8241C16.4822 8.5 17.1255 8.69479 17.6731 9.05983L18.9622 9.91928C19.1941 10.0738 19.3333 10.334 19.3333 10.6127V17.4454C19.3333 17.5904 19.2955 17.7329 19.2235 17.8588L16 23.5H14.8927C13.2288 23.5 12.2363 21.6455 13.1593 20.261L14.3333 18.5H9.80128C8.71699 18.5 7.92139 17.481 8.18437 16.4291L9.53543 11.0249C9.9064 9.54099 11.2397 8.5 12.7692 8.5Z",
    stroke: "#4B4B4B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDislikeIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dislikeIcon.013b1df810ca1c0656a56c34a13d0a62.svg";